import ThemedComponent from '../../hoc/ThemedComponent';
import GlobalPostbackPage from './GlobalPostbackPage';
import { default as GlobalPostbackPage3 } from '../../themes/3/pages/postback/GlobalPostbackPage';
import { default as GlobalPostbackPage4 } from '../../themes/4/pages/postback/GlobalPostbackPage';

const ThemedGlobalPostbackPages = {
    default: GlobalPostbackPage,
    // 3: GlobalPostbackPage3,
    // 4: GlobalPostbackPage4,
};

export const ThemedGlobalPostbackPage = ThemedComponent(ThemedGlobalPostbackPages);